import { Icon, IconProps } from "@chakra-ui/react";

const HomeFilled = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        d="M21.743 12.3302L12.743 2.33017C12.364 1.90817 11.636 1.90817 11.257 2.33017L2.25698 12.3302C2.12744 12.4738 2.04241 12.6519 2.01223 12.8429C1.98205 13.034 2.00802 13.2296 2.08698 13.4062C2.24698 13.7672 2.60498 13.9992 2.99998 13.9992H4.99998V20.9992C4.99998 21.2644 5.10534 21.5187 5.29288 21.7063C5.48041 21.8938 5.73477 21.9992 5.99998 21.9992H8.99998C9.2652 21.9992 9.51955 21.8938 9.70709 21.7063C9.89463 21.5187 9.99998 21.2644 9.99998 20.9992V16.9992H14V20.9992C14 21.2644 14.1053 21.5187 14.2929 21.7063C14.4804 21.8938 14.7348 21.9992 15 21.9992H18C18.2652 21.9992 18.5196 21.8938 18.7071 21.7063C18.8946 21.5187 19 21.2644 19 20.9992V13.9992H21C21.1937 14 21.3834 13.9445 21.546 13.8393C21.7087 13.7342 21.8372 13.584 21.916 13.4071C21.9947 13.2301 22.0203 13.0341 21.9896 12.8429C21.9589 12.6517 21.8732 12.4735 21.743 12.3302Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default HomeFilled;
